import { LocaleUser } from '../en/user'

const user: LocaleUser = {
  changePass: '更换密码',
  editProfile: '编辑个人主页',
  emailVerifiedSuccess: '电子邮箱已验证',
  emailCantVerified: '您的电子邮箱无法验证',
  changeLang: '改变语言',
  english: '英语',
  vietnamese: '越南语',
  chineseSimplified: '简体中文',
  spanish: '西班牙语',
  chineseTraditional: '繁体中文',
  malay: '马来语',
}

export default user
